import { createContext, useState } from 'react';

export const SkuContext = createContext();

export const SkuProvider = ({ children }: { children: null | Node }) => {
  const [sku, setSku] = useState(null);

  return (
    <SkuContext.Provider value={{ sku, setSku }}>
      {children}
    </SkuContext.Provider>
  );
};
